export default "__VITE_ASSET__DBpAtaSC__"